import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

/** Use when a single block of content shows and hides behind a trigger. */
const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export { Collapsible, CollapsibleContent, CollapsibleTrigger };
